import type { CSSProperties } from "react";

// Caveat handwritten accent — used for kickers, captions, annotations.
export const handwritten: CSSProperties = {
  fontFamily: "'Caveat', cursive",
};

// EventsPage editorial palette. These resolve to the same design-token CSS
// variables the Tailwind `bg-paper*` utilities use, so surfaces that apply
// them via inline style flip with the light/dark theme instead of being pinned
// to a literal hex. Light-mode values are identical to the old literals
// (--color-paper #F9F9F7, --color-paper-tan #F0EFEB, --color-paper-salmon
// #FFF0E0, --color-paper-mint #E8F5E9); dark values are remapped in styles.css.
export const PAPER = "var(--color-paper)"; // page background (app cream)
export const PAPER_TAN = "var(--color-paper-tan)"; // alternating section background (app paper2)
export const PAPER_SALMON = "var(--color-paper-salmon)"; // accent section background
export const PAPER_MINT = "var(--color-paper-mint)"; // community / proof background
